.rating-container {
  display: flex;
  gap: var(--dds-spacing-x1);
}

.rating-container--horizontal {
  flex-direction: row;
  align-items: center;
}

.rating-container--vertical {
  flex-direction: column;
  align-items: start;
}

.rating-submitted-title {
  display: inline-flex;
  align-items: center;
  gap: var(--dds-spacing-x0-5);
}

.button {
  border-radius: var(--dds-border-radius-button);
  color: var(--dds-color-icon-medium);

  &:hover {
    background-color: var(--dds-color-surface-hover-default);
    color: var(--dds-color-icon-action-hover);
  }

  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

.button--horizontal {
  width: var(--dds-size-icon-medium);
  height: var(--dds-size-icon-medium);
}

.button--vertical {
  width: var(--dds-size-icon-large);
  height: var(--dds-size-icon-large);
}
